export default function highlightTask (state, taskId = null) {
  state.highlightedTaskId = taskId
}
